import {assert} from 'Asserts';
import * as SpreadsheetBulkImportConstants from 'bulk-import/SpreadsheetBulkImportConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';

import {ColumnDefinitionForSpreadsheetImport} from './ColumnDefinitionForSpreadsheetImport';

/**
 * This function takes the results of a spreadsheet import and prepares
 * them for insertion into the table. The output is a 2D matrix of text-only cells.
 */

export interface ImportedStructuredTableRow {
  nonSchemaFieldCellsByColumnType: {[columnType: string]: string};
  // Field ID is the numeric dbId, not the API ID
  schemaFieldCellsByFieldId: {[schemaFieldId: number]: string};
}

interface TextCell {
  text: string;
}

function isSpreadsheetColumnTypeForSchemaField(
  spreadsheetColumnType: SpreadsheetBulkImportConstants.COLUMN_TYPE
): boolean {
  return (
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.CONTAINER_SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.RESULT_SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.PROCESS_TASK_SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.PROCESS_OUTPUT_SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.PLATE_SCHEMA_FIELD ||
    spreadsheetColumnType === SpreadsheetBulkImportConstants.COLUMN_TYPE.BOX_SCHEMA_FIELD
  );
}

export default function prepareImportedRows(
  importedRows: Array<ImportedStructuredTableRow>,
  columnDefinitionsForImport: Array<ColumnDefinitionForSpreadsheetImport>
): Array<Array<TextCell>> {
  return importedRows.map(({nonSchemaFieldCellsByColumnType, schemaFieldCellsByFieldId}) => {
    const newRow: Array<TextCell> = [];
    for (const {columnDefinition, spreadsheetColumnType} of columnDefinitionsForImport) {
      let importedTextValue: string | null;
      if (spreadsheetColumnType == null) {
        importedTextValue = null;
      } else if (
        isSpreadsheetColumnTypeForSchemaField(spreadsheetColumnType) &&
        columnDefinition.type === TableColumnType.TAG_VALUE
      ) {
        // This function is not used for rendering, but for editing the table, so its ok to access live schemaField
        importedTextValue = schemaFieldCellsByFieldId[columnDefinition.schemaField.id];
      } else {
        assert(
          columnDefinition.type !== TableColumnType.TAG_VALUE,
          'Unexpected column type mismatch between spreadsheet and structured table'
        );
        importedTextValue = nonSchemaFieldCellsByColumnType[spreadsheetColumnType];
      }
      newRow.push({text: importedTextValue ?? ''});
    }
    return newRow;
  });
}
